module.exports = __webpack_public_path__ + "img/5.fd803489.jpg";